import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

// Componentes de selección
// Asumimos que ComboMultiSelectCertificados existe o usas uno similar
import ComboMultiSelectCertificados from "../../../components/multiselect/ComboMultiSelectCertificados";

// TU COMPONENTE REUTILIZABLE (Asegúrate que esta ruta sea correcta relativa a este archivo)
import ComboMultiSelectClientes from "../../../components/Modales/ComboMultiSelectClientes";

export default function CrearCertificadoCliente({
  onClose = () => {},
  onCreated = () => {},
  // Datos precargados que vienen del padre (GestionarCertificadoModal)
  listaCertificadosPreloaded = [],
  listaClientesPreloaded = [],
  // Nuevas props para modo Wizard
  embedded = false,
  certificadoPredefinido = null,
}) {
  
  // --- ESTADOS ---

  // 1. CERTIFICADOS
  // Si hay uno predefinido (paso 1 del wizard), lo seleccionamos automáticamente.
  const [selectedCertificadosIds, setSelectedCertificadosIds] = useState(
    certificadoPredefinido ? [certificadoPredefinido.id] : []
  );

  useEffect(() => {
    if (certificadoPredefinido) {
      setSelectedCertificadosIds([certificadoPredefinido.id]);
    }
  }, [certificadoPredefinido]);

  // 2. CLIENTES
  const [selectedClientesIds, setSelectedClientesIds] = useState([]);

  // Estado de guardado
  const [saving, setSaving] = useState(false); 
  const [error, setError] = useState(null);

  // 3. HISTORIAL (NUEVO ESTADO)
  const [listaAsignados, setListaAsignados] = useState([]);

  // --- EFECTO: CARGAR HISTORIAL ---
  useEffect(() => {
    if (certificadoPredefinido?.id) {
        fetchHistorial(certificadoPredefinido.id);
    }
  }, [certificadoPredefinido]);

  const fetchHistorial = async (certId) => {
      try {
          const url = apiRoutes.certificadoCliente.listUrl({
              certificadoId: certId,
              size: 1000 
          });
          const res = await appFetchJson(url);
          const items = res.items || res.content || [];
          setListaAsignados(items);
      } catch (e) {
          console.error("Error cargando historial de clientes:", e);
      }
  };

  // Validación
  const isValid = 
    selectedCertificadosIds.length > 0 && 
    selectedClientesIds.length > 0;

  // Cerrar con ESC (Solo si no es embedded)
  useEffect(() => {
    if (embedded) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, embedded]);

  // Guardar
  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");

    try {
      const payload = {
        certificadosIds: selectedCertificadosIds,
        clientesIds: selectedClientesIds
      };
      
      const url = apiRoutes.certificadoCliente.create; 
      
      await appFetchJson(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      onCreated(); 
      onClose();
    } catch (e) {
      console.error(e);
      setError(e?.message || "Ocurrió un error al guardar.");
    } finally {
      setSaving(false);
    }
  };

  // === RENDERIZADO ===
  const content = (
    <>
      {/* HEADER: Solo si NO es embedded */}
      {!embedded && (
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Asignar Clientes a Certificados</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
      )}

      {/* BODY */}
      <div className={embedded ? "overflow-visible" : "modal-body overflow-y-auto p-6"}>
        {!embedded && (
          <p className="text-gray-600 mb-4 italic">
             Seleccione uno o más certificados y asigne los clientes correspondientes.
          </p>
        )}

        {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
        
        <div className="form-grid gap-6">
          
          {/* 1. SELECCIÓN DE CERTIFICADOS */}
          <div className="form-row col-span-2">
            {certificadoPredefinido ? (
               // CASO A: MODO WIZARD (Solo lectura)
               <div>
                  <label className="form-label">Certificado Seleccionado:</label>
                  <input 
                      type="text" 
                      className="input bg-gray-100 text-gray-700 font-semibold cursor-not-allowed" 
                      value={certificadoPredefinido.numero || "Sin Numero"} 
                      readOnly 
                      disabled
                  />
                  <p className="text-xs text-gray-400 mt-1 ml-1">
                    Este es el certificado creado en el paso anterior.
                  </p>
               </div>
            ) : (
               // CASO B: MODO NORMAL (Multiselect)
               <>
                 <ComboMultiSelectCertificados
                   label="Impuesto al Valor Selectivo (Certificados) *"
                   items={listaCertificadosPreloaded}
                   selected={selectedCertificadosIds}
                   onChange={setSelectedCertificadosIds}
                   loading={false}
                 />
                 <p className="text-xs text-gray-400 mt-1 ml-1">
                   Se aplicarán los cambios a los certificados seleccionados.
                 </p>
               </>
            )}
          </div>

          {/* 2. SELECCIÓN DE CLIENTES (Usando tu componente reutilizable) */}
          <div className="form-row col-span-2">
            <ComboMultiSelectClientes
              label="Clientes *"
              items={listaClientesPreloaded} 
              loading={false}
              selected={selectedClientesIds}
              onChange={setSelectedClientesIds}
            />
            <p className="text-xs text-gray-400 mt-1 ml-1">
              Estos clientes serán vinculados al certificado seleccionado.
            </p>
          </div>

        </div>
      </div>

      {/* FOOTER */}
      <div className={embedded ? "mt-6" : "modal-footer"}>
        <div className="btn-row">
          <BtnGuardar 
            label="Asignar clientes" 
            isValid={isValid} 
            saving={saving} 
            onClick={guardar} 
          />
          {!embedded && <BtnCancelar onClick={onClose} />}
        </div>
      </div>

      {/* === NUEVA SECCIÓN: TABLA DE HISTORIAL === */}
      {embedded && listaAsignados.length > 0 && (
        <div className="mt-6 animate-fadeIn">
            <h3 className="text-sm font-bold text-gray-700 mb-2 pl-2 border-l-4 border-green-600">
                Historial de Clientes Asignados
            </h3>
            
            <div className="overflow-x-auto border rounded-lg shadow-sm">
                <table className="table-card table-xs w-full">
                    <thead className="bg-green-700 text-white">
                        <tr>
                            <th className="px-3 py-2 text-left">Código</th>
                            <th className="px-3 py-2 text-left">Cliente / Razón Social</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {listaAsignados.map((item, idx) => (
                            <tr key={item.id || idx} className="hover:bg-gray-50">
                                <td className="px-3 py-2 font-mono text-xs text-gray-600">
                                    {item.clienteCodigo || item.cliente?.codigo || "—"}
                                </td>
                                <td className="px-3 py-2 font-medium text-gray-800">
                                    {item.clienteNombre || item.cliente?.nombre || item.cliente?.razonSocial || "Sin nombre"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="text-right text-xs text-gray-400 mt-1">
               Mostrando {listaAsignados.length} cliente(s) asignados previamente.
            </div>
        </div>
      )}
    </>
  );

  // MODO EMBEDDED
  if (embedded) {
    return <div className="bg-white p-1">{content}</div>;
  }

  // MODO MODAL NORMAL
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div 
        className="modal-panel-md overflow-hidden flex flex-col max-h-[90vh]" 
        onClick={(e) => e.stopPropagation()}
      >
        {content}
      </div>
    </div>
  );
}